export default __webpack_public_path__ + "icon_interior.d1d2974c376cee9296122844dc77dcfe.svg";